// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 获取用户推送订阅信息 GET /notice-sub/filter */
export async function noticeSubFilterUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.noticeSubFilterUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListNoticeSubInfoResp>('/notice-sub/filter', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取推送订阅信息 GET /notice-sub/me */
export async function noticeSubMeUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.noticeSubMeUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultboolean>('/notice-sub/me', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取推送订阅列表 GET /notice-sub/push-subscription/list */
export async function noticeSubPushSubscriptionListUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultListNoticePushSubscriptionResp>(
    '/notice-sub/push-subscription/list',
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

/** 设置推送订阅状态 POST /notice-sub/push-subscription/set */
export async function noticeSubPushSubscriptionSetUsingPOST(
  body: API.NoticePushSubscriptionSetReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/notice-sub/push-subscription/set', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 设置推送订阅信息 POST /notice-sub/set */
export async function noticeSubSetUsingPOST(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.noticeSubSetUsingPOSTParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/notice-sub/set', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
